<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
            <el-form-item label="类型">
                <el-select v-model="formInline.periodType" clearable @change="findList" placeholder="是否投票">
                    <el-option label="周" value="0"></el-option>
                    <el-option label="月" value="1"></el-option>
                    <el-option label="季度" value="2"></el-option>
                    <el-option label="年" value="3"></el-option>
                    <el-option label="日" value="4"></el-option>
                </el-select>
            </el-form-item>
        </el-form>

        <el-table :data="PeriodList" stripe border center :size="GCONFIG.styleTableSize">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="id" label="ID"></el-table-column>
            <el-table-column prop="periodType" label="期次类型"></el-table-column>
            <el-table-column prop="headYear" label="年"></el-table-column>
            <el-table-column prop="headPeriod" label="期"></el-table-column>
            <el-table-column prop="periodStart" label="开始日期"></el-table-column>
            <el-table-column prop="periodEnd" label="结束日期"></el-table-column>
            <el-table-column prop="participantNumber" label="参与人数"></el-table-column>
            <el-table-column prop="periodDesc" label="描述"></el-table-column>
            <el-table-column label="操作" fixed="right">
                <template slot-scope="scope">
                    <el-button type="danger" size="mini" @click="handleBuildPaper(scope.row.id)">生成paper</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {findPeriodList,buildPaper} from '@/api/api';
    export default {
        data() {
            return {
                PeriodList: [],
                loading: true,
                formInline: {
                    periodType: "0",// 默认0，周
                    platformId: 1,
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0
                }
            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.findList();
        },
        methods: {
            findList(){
                findPeriodList(this.formInline).then((res) => {
                    if (res.data.status == 200) {
                        this.formInline.recordsTotal = res.data.value.total;
                        this.PeriodList = res.data.value.list;
                        for(var i = 0; i < this.PeriodList.length;i++){
                            this.PeriodList[i].periodStart = this.PeriodList[i].periodStart.substring(0,10);
                            this.PeriodList[i].periodEnd = this.PeriodList[i].periodEnd.substring(0,10);
                        }
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            handleBuildPaper(periodId){
                buildPaper({'periodId':periodId}).then((res) => {
                    this.loading = false;
                    if (res.data.success) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                    this.loading = false;
                });
            },
            returnHistory(){
                window.history.back()
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.findList();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.findList();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/cooperative-manage/Periods.vue